// Must match session.timeout.master.minutes in the backend application-*.properties:
// prod and awstest use 120, dev uses 30. guardianware-service.sh sets REACT_APP_ENV=production
// for every server build; local `npm start` and Jest leave it unset.
export const SESSION_TTL_MINUTES =
  process.env.REACT_APP_ENV === "production" ? 120 : 30;
